import React, {Component} from 'react';
import styles from "./record.module.css";
import {FILE_URL} from "../../util/constants";
import icDelete from "../../img/delete.png";
import closeIcon from "../../img/bt-close.png";
import defaultIcon from "../../img/bee.png";


const Record = props => (
    <div className={styles["modal-overlay"]}>
        <div className={styles["modal-content"]}>
            <div className={styles.titlebar}>
                <div className={styles["text-name"]}>
                    徽章记录
                </div>

                <img
                    className={styles.close}
                    src={closeIcon}
                    onClick={props.onRequestClose}
                />
            </div>

            <div className={styles.list}>
                {
                    props.recordList.length > 0 ? (
                            <React.Fragment>
                                {
                                    props.recordList.map((item, index, array) => {

                                        var s = item.dongtai_title.split(",");

                                        return (
                                            <div className={styles['list-item']}>

                                                <div className={styles['list-item-top']}>
                                                    <img
                                                        className={styles['list-item-touxiang']}
                                                        src={item.student_pic}
                                                        onError={props.handleImageErrored.bind(this, index)}
                                                    />


                                                    <div className={styles['div-name']}>
                                                        <div className={styles['item-name']}>{item.student_name}</div>
                                                        <div className={styles['item-date']}>{item.dongtai_time}</div>
                                                    </div>
                                                </div>

                                                {item.honglingjin_hz=='0'?
                                                    <div className={styles['list-item-bottom']}>
                                                        <img className={styles["item-pic_badge"]} src={FILE_URL+ item.dongtai_pic}/>
                                                        <div className={styles['item-name-badge']}>{item.dongtai_title}</div>
                                                        <div
                                                            className={styles['item-content-badge']}>{item.huizhang_shuoming}</div>
                                                    </div>
                                                :
                                                    <div className={styles['list-item-bottom2']}>
                                                        <img className={styles["item-pic_badge2"]} src={FILE_URL+ item.dongtai_pic}/>
                                                        <div className={styles['div-name']}>
                                                            <div className={styles['item-hlj-name']}>{s[0]}</div>
                                                            <div className={styles['item-hlj-name2']}>{s[1]}</div>
                                                        </div>
                                                    </div>
                                                }


                                            </div>
                                        );
                                    })
                                }
                            </React.Fragment>
                        )
                        : (<div className={styles['no-data']}>暂无记录</div>)
                }

            </div>


        </div>
    </div>
)

export default Record;
